// extracted by mini-css-extract-plugin
export default {"card":"GenericCard_card__b59nt","bar":"GenericCard_bar__f46mh","barGradient":"GenericCard_barGradient__HGylO"};